import React from "react";
import { useAuth } from "../contexts/AppKitAuthContext";
import { formatDXFBalance } from "../utils/gameCalculations";

interface LoginProps {
  onLoginSuccess?: () => void;
  onWalletAddressClick?: () => void;
}

const Login: React.FC<LoginProps> = ({ onLoginSuccess, onWalletAddressClick }) => {
  const {
    login,
    isAuthenticated,
    walletAddress,
    isLoading,
    walletState,
    isInitializing,
    openAccount,
  } = useAuth();

  const handleSignIn = async () => {
    try {
      await login(); // This handles everything now - connection and authentication

      if (onLoginSuccess) {
        onLoginSuccess();
      }
    } catch (err) {
      // Error is already handled in the context
      console.error("Authentication failed:", err);
    }
  };


  // Show loading state during initialization
  if (isInitializing) {
    return (
      <div className="login-container">
        <button
          disabled={true}
          className="btn btn-primary login-btn"
          type="button"
        >
          Loading...
        </button>
      </div>
    );
  }

  // Authenticated state - show wallet info with clickable address
  if (isAuthenticated && walletAddress) {
    return (
      <div className="login-container connected">
        <div className="wallet-info">
          <button 
            onClick={() => {
              openAccount();
              onWalletAddressClick?.();
            }} 
            className="wallet-address clickable"
            type="button"
          >
            <span className="address">{`${walletAddress.slice(0, 6)}...${walletAddress.slice(-4)}`}</span>
          </button>
          {walletState.address && walletState.dxfBalance && (
            <div className="wallet-balance">
              <a 
                href="https://deathx-fun.notion.site/DeathX-Fun-Token-24e1b048608b81168d99dc0e802cdb93"
                target="_blank"
                rel="noopener noreferrer"
                className="dxf-balance-link"
              >
                {formatDXFBalance(walletState.dxfBalance)} DXF
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Unauthenticated state - single "Sign In" button for all scenarios
  // The login() method in AuthContext handles both wallet connection and authentication
  return (
    <div className="login-container">
      <button
        onClick={handleSignIn}
        disabled={isLoading}
        className="btn btn-primary login-btn"
        type="button"
      >
        {isLoading ? "Connecting..." : "Sign In"}
      </button>
    </div>
  );
};

export default Login;
